// extracted by mini-css-extract-plugin
export default {"back_link":"back-btn_back_link__cxPVH"};